var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactivateProjectsIlls(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 178,
    viewBox: "0 0 422 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.532 23.7256C139.815 26.0542 140.119 28.3793 140.423 30.7053",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.007 17.6368C134.94 18.9533 134.831 18.762 133.278 21.2009C132.039 23.1478 130.393 26.7979 129.615 28.9727C129.28 29.9085 128.543 32.0201 128.906 33.2628C129.236 34.3959 130.985 35.4473 131.9 35.9524C134.299 37.2762 137.04 38.0284 139.722 38.51C141.993 38.9179 145.07 39.589 147.37 38.972C151.912 37.7533 152.536 30.5555 150.596 27.0999C149.151 24.5279 146.632 22.5323 144.441 20.6151C142.468 18.8886 140.548 17.8669 137.898 17.4883",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M241.554 18.9736C241.716 21.1995 239.819 23.7548 238.485 25.3923C238.344 25.5657 236.655 27.0018 237.075 26.9847C240.995 26.8247 244.907 26.6959 248.831 26.6959",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M237.248 18.8247C237.39 17.2236 238.421 16.9812 239.773 17.0426C240.576 17.0791 240.812 17.4878 240.812 18.2307",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M244.673 14.3699C239.235 12.6025 230.227 11.4505 227.001 17.5875C225.451 20.5368 225.636 24.4958 227.323 27.3476C229.94 31.7706 235.556 33.4264 240.317 33.9396C242.543 34.1795 244.813 34.1719 247.049 34.1211C249.412 34.0674 251.757 33.3215 253.336 31.481C254.877 29.6857 254.982 27.0331 254.92 24.7818C254.854 22.3726 253.129 19.8721 251.447 18.1898C249.758 16.5008 247.496 14.7498 245.119 14.2214",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.004 1.4668C128.104 11.6405 107.024 19.261 82.8968 21.6888C82.0513 21.7739 68.4703 22.9619 69.8969 24.5387C74.4721 29.5954 78.18 33.4131 81.101 39.8028C84.3192 46.8427 87.5825 53.8517 89.5724 61.3521C91.2587 67.7083 93.456 74.1849 94.3351 80.7153C95.7502 91.2273 95.194 102.071 95.194 112.649C95.194 122.526 94.3327 132.889 95.6624 142.709C96.7877 151.019 98.5509 158.656 98.7074 167.147C98.7142 167.513 99.0637 179.016 100.503 175.657C102.656 170.633 104.354 167.305 108.858 163.907C119.117 156.164 129.744 152.522 142.392 150.477C154.823 148.468 166.366 147.628 178.971 147.628C186.07 147.628 193.189 147.785 200.286 147.628C202.162 147.586 201.301 143.932 201.301 142.709",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.706 1.4668C153.445 10.9289 158.613 19.3541 162.417 28.4035C167.239 39.8744 170.937 51.6985 176.549 62.8356C180.248 70.1759 182.053 78.3842 185.372 85.9465C188.697 93.5242 190.196 102.346 192.126 110.385C193.307 115.307 193.286 120.201 194.624 125.141C195.417 128.069 196.286 131.389 197.435 134.198C198.341 136.413 199.645 138.301 200.909 140.288C201.196 140.739 201.518 141.721 201.222 142.24C200.658 143.226 197.182 137.235 197.084 137.087",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.679 45.034C170.5 34.0133 170.163 22.5274 169.328 11.4998C169.257 10.5596 168.083 5.18531 169.601 4.58992C170.472 4.24849 173.817 4.28075 174.13 4.27761C179.815 4.22047 185.504 4.27761 191.19 4.27761C205.165 4.27761 219.141 4.27761 233.117 4.27761C239.826 4.27761 246.9 3.7178 253.612 4.43376C259.576 5.06987 260.209 6.01117 260.874 12.1634C261.414 17.1624 262.918 21.8527 263.489 26.881C264.273 33.7813 263.841 40.8754 263.841 47.8057C263.841 68.1319 263.841 88.458 263.841 108.784C263.841 116.709 263.841 124.634 263.841 132.559C263.841 134.073 263.247 136.876 264.231 138.141C265.951 140.353 265.715 144.387 266.105 147.003C266.194 147.6 268.183 154.049 265.871 152.508C261.27 149.441 254.663 148.045 249.396 146.535C241.957 144.4 235.316 144.114 227.613 144.114C220.404 144.114 213.194 144.114 205.985 144.114C202.739 144.114 198.593 144.868 195.679 143.411",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.219 49.2501C102.486 53.3401 103.799 61.1959 108.856 61.1959C110.316 61.1959 114.165 61.289 114.165 59.3611C114.165 54.9918 112.631 51.0941 111.354 46.9468C110.783 45.0897 101.209 48.3721 100.111 49.2501",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M107.14 82.2769C124.542 77.3236 141.451 73.4492 159.451 71.5803C161.918 71.3242 165.128 71.3084 167.572 70.3311",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M107.842 99.845C112.861 99.845 117.991 98.8774 122.599 97.0342",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.896 137.79C135.247 133.598 148.044 132.871 161.95 132.871",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M181.624 26.061C181.624 31.2141 181.624 36.3672 181.624 41.5204C181.624 42.2848 181.192 45.2263 182.015 46.0488C183.22 47.2546 187.469 46.4392 189.003 46.4392C189.852 46.4392 193.894 47.0734 194.585 46.2831C196.395 44.2145 194.24 37.1963 193.96 35.0009C193.463 31.0948 194.281 26.3816 191.306 23.4064C190.305 22.4057 184.839 24.1023 183.732 24.6556",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M180.219 67.5205H247.678",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M184.436 80.8711C191.464 81.3166 198.49 81.7974 205.516 82.2765",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M194.273 119.52C210.307 119.52 227.951 117.546 243.462 121.628",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7876 159.98C12.9112 157.377 22.8337 151.309 34.0269 148.772C43.1634 146.701 53.9946 146.568 62.9369 149.326C70.4959 151.658 78.2433 155.311 86.076 156.596C90.3868 157.302 94.8071 156.984 99.1714 156.984",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M420.788 149.992C400.518 144.743 379.843 136.926 358.75 136.12C348.055 135.712 336.567 135.048 325.956 136.564C320.656 137.321 315.673 139.851 310.419 140.393C304.354 141.018 298.157 139.899 292.108 140.781C284.168 141.939 276.515 142.002 268.469 142.002",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M282.359 75.1328C282.359 75.9602 282.136 77.1134 282.392 77.9026C282.54 78.3606 285.056 77.9688 285.226 77.6288C285.626 76.8279 285.232 76.0015 284.501 75.7125C284.097 75.5528 282.939 75.3164 282.939 76.0024",
    stroke: "#FB7C51",
    strokeWidth: 2.40219,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M342.782 54.6133C342.901 66.892 342.394 67.7859 342.782 80.0585",
    stroke: "#FB7C51",
    strokeWidth: 2.40219,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M341.26 85.5357C341.26 86.0062 341.056 86.919 341.683 87.0235C342.236 87.1157 344.608 87.4576 344.608 86.6008C344.608 86.2685 344.723 85.752 344.405 85.5357C343.14 84.6752 343.391 86.2523 343.391 87.0573",
    stroke: "#FB7C51",
    strokeWidth: 2.40219,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M264.916 46.1053C264.916 43.5002 266.648 40.7955 269.39 40.3893C271.102 40.1356 271.947 39.1243 273.628 38.9899C274.887 38.8891 275.978 38.1299 277.215 37.9649C289.115 36.3783 304.244 34.6904 314.546 42.1829C315.959 43.2106 317.221 44.1475 318.488 45.3957C319.499 46.3911 321.014 47.2812 321.602 48.5887C322.385 50.3285 323.37 52.0755 324.086 53.8317C324.389 54.575 325.162 55.6552 325.229 56.394C325.836 63.071 325.584 69.8268 325.584 76.5378C325.584 79.3509 325.218 82.0193 324.697 84.7964C324.191 87.4946 324.228 89.4753 323.1 91.8921C322.679 92.7951 321.326 95.0392 321.326 95.9721C321.326 97.0215 319.697 99.2296 318.863 99.855C317.628 100.781 316.629 102.286 315.532 103.383C313.872 105.042 312.34 105.558 310.151 106.044C303.626 107.494 296.899 107.128 290.105 107.128C281.34 107.128 272.805 107.942 264.561 104.645",
    stroke: "#FB7C51",
    strokeWidth: 2.40219,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M285.548 77.4512H306.009",
    stroke: "#FB7C51",
    strokeWidth: 2.40219,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M301.415 73.5391C303.063 74.4002 304.719 75.2188 306.101 76.486C306.201 76.5778 307.307 77.5024 307.043 77.6293C304.945 78.6363 303.512 80.1455 302.284 82.0899",
    stroke: "#FB7C51",
    strokeWidth: 2.40219,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M282.896 77.2416C289.171 68.9596 295.273 60.56 301.414 52.1797",
    stroke: "#FB7C51",
    strokeWidth: 2.40219,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M297.238 52.7371C297.422 53.4736 300.02 52.1108 300.579 52.0409C300.912 51.9994 301.22 51.8078 301.539 51.716C302.194 51.5275 301.968 52.47 301.987 52.8686C302.077 54.7344 302.529 56.5744 302.529 58.4456",
    stroke: "#FB7C51",
    strokeWidth: 2.40219,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateProjectsIlls);
export default __webpack_public_path__ + "static/media/deactivateProjectsIlls.5abff8fc7e4ae7ccea2c9508313f25c4.svg";
export { ForwardRef as ReactComponent };